import { readPersistedSessionIds } from './kronosPrefs/sessionIds';
import { readUserInstancePrefString, writeUserInstancePrefString } from './kronosPrefs/userInstancePrefs';

const INSTANCE_LAST_PLACE_PATH = 'programmations.lastPlaceId';

/**
 * @param {string|null|undefined} placeId
 * @param {string|null|undefined} instanceId  Mongo id of `tkt_instance` or `'none'`
 */
export function writeLastProgrammationPlaceId(placeId, instanceId) {
    if (placeId == null || placeId === '') {
        return;
    }
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    writeUserInstancePrefString(userId, inst, INSTANCE_LAST_PLACE_PATH, String(placeId));
}

/**
 * @param {string|null|undefined} [instanceId]
 * @returns {string|null}
 */
export function readLastProgrammationPlaceId(instanceId) {
    const { userId, instanceId: instFromSession } = readPersistedSessionIds();
    if (!userId) {
        return null;
    }
    const inst = instanceId != null ? String(instanceId) : instFromSession;
    const v = readUserInstancePrefString(userId, inst, INSTANCE_LAST_PLACE_PATH);
    return v && String(v).trim() ? String(v).trim() : null;
}

/**
 * @param {Array<{ _id?: string }>} places
 * @param {string|null|undefined} id
 * @returns {boolean}
 */
function placeIdIsKnown(places, id) {
    if (id == null || id === '') {
        return false;
    }
    const list = Array.isArray(places) ? places : [];
    return list.some((p) => p && String(p._id) === String(id));
}

/**
 * Default place for programmation forms (standalone + group).
 *
 * @param {{ places: Array<{ _id?: string }>, programmationPlaceId?: string|null, singlePlaceFromStoreId?: string|null }} args
 * @returns {string|null}
 */
export function pickDefaultProgrammationPlaceId({ places, programmationPlaceId, singlePlaceFromStoreId }) {
    if (programmationPlaceId != null && programmationPlaceId !== '') {
        return programmationPlaceId;
    }
    const list = Array.isArray(places) ? places : [];
    const marked_default = list.find((p) => p?.is_default === true);
    if (marked_default?._id) {
        return marked_default._id;
    }
    if (list.length === 1) {
        return list[0]._id ?? null;
    }
    if (singlePlaceFromStoreId != null && singlePlaceFromStoreId !== '' && placeIdIsKnown(list, singlePlaceFromStoreId)) {
        return singlePlaceFromStoreId;
    }
    const stored = readLastProgrammationPlaceId();
    if (placeIdIsKnown(list, stored)) {
        return stored;
    }
    return null;
}

/**
 * Persist the last non-empty place_id from a list (uses the last row).
 *
 * @param {Array<{ place_id?: string|null }>|undefined|null} programmations
 * @param {string|null|undefined} instanceId
 */
export function rememberLastPlaceFromProgrammationsList(programmations, instanceId) {
    if (!Array.isArray(programmations) || programmations.length === 0) {
        return;
    }
    const inst = instanceId != null ? String(instanceId) : readPersistedSessionIds().instanceId;
    for (let i = programmations.length - 1; i >= 0; i--) {
        const pid = programmations[i]?.place_id;
        if (pid != null && pid !== '') {
            writeLastProgrammationPlaceId(pid, inst);
            return;
        }
    }
}
